// Wer angemeldet ist und welche Bereiche er öffnen darf - für die Seiten, die das brauchen
// (Bereichsauswahl, Zugänge in den Einstellungen), ohne es durch jede Ebene zu reichen.

import { createContext, useContext } from 'react'

import type { Benutzer, BereichId } from './typen'

export interface Sitzung {
  benutzer: Benutzer
  bereiche: BereichId[]
}

export const SitzungKontext = createContext<Sitzung | null>(null)

/** Die Sitzung; außerhalb von App (Anmeldeschirm) gibt es keine - das ist ein Programmierfehler. */
export function useSitzung(): Sitzung {
  const sitzung = useContext(SitzungKontext)
  if (!sitzung) throw new Error('useSitzung braucht den SitzungKontext aus App.tsx.')
  return sitzung
}
